import { FUNNEL_TEMPLATE_SLUG_PREFIX } from "@fitness-app/data-models/landing-templates/template";

export const LANDING_SLUG_PREFIX = "metamorfoza/";

export { FUNNEL_TEMPLATE_SLUG_PREFIX };

export const normalizeLandingSlug = (slug: string) => {
  const normalizedSlug = slug.replace(/^\/+|\/+$/g, "");

  if (!normalizedSlug) {
    return "";
  }

  if (normalizedSlug === "pakiety" || normalizedSlug === "metamorfoza2026") {
    return normalizedSlug;
  }

  // Funnel templates (TRE-2356) live outside `/metamorfoza/*`: they render on funnel steps only.
  if (normalizedSlug.startsWith(LANDING_SLUG_PREFIX) || normalizedSlug.startsWith(FUNNEL_TEMPLATE_SLUG_PREFIX)) {
    return normalizedSlug;
  }

  return `${LANDING_SLUG_PREFIX}${normalizedSlug}`;
};

/** Slug of a funnel page: always under `szablony/`. */
export const normalizeFunnelPageSlug = (slug: string) => {
  const normalizedSlug = slug
    .replace(/^\/+|\/+$/g, "")
    .replace(/^szablony\//, "")
    .replace(new RegExp(`^${LANDING_SLUG_PREFIX}`), "");
  return `${FUNNEL_TEMPLATE_SLUG_PREFIX}${normalizedSlug || "strona"}`;
};
